import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconFiletypePpt = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={100}
      height={114.508}
      viewBox="0 0 26.458 30.297"
      className="block w-full h-full fill-current"
    >
      <path
        d="M3.508 27.992l-.038-2.16-1.679-.194-1.68-.195V11.006l1.68-.195 1.68-.195.035-5.244.036-5.244H19.65l3.324 3.326 3.323 3.325v23.372H3.546z"
        fill="#fff"
      />
      <path
        d="M6.306 27.09l.001-.629 1.221-.001.012 1.232H6.306zm2.468.054c0-.302-.032-.632.024-.63.057.002.83.179 1.62.287 1.84.252-.575.168-.575-.154 0-.27 2.45-.189 8.047-.189h5.69v1.234H8.773zm3.427-2.948v-.617h11.378v1.234H12.201zm0-2.879v-.616h11.378v1.233H12.201zm0-2.878v-.617h11.378v1.233H12.201zM15.765 6.56V3.937l.75.03c.839.128 1.852.362 2.317.798.5.449.803.629.498 1.496l.479.693.693-.087c.187.29.343.682.343.682.111.508.15.728.163 1.174l.005.462h-5.248z"
        fill="#f3b79a"
      />
      <path
        d="M3.427 28.103c0-.929-.02-2.208.008-2.524.028-.316.08-.4.173-.4.274-.319.23.426.23 2.719v1.988h22.209V7.129H19.33V.41H3.839v5.073c0 6.553-.046 9.507-.225 9.507-.18 0-.187-2.99-.187-9.713V0h16.247l3.392 3.394 3.392 3.394v23.509H3.427zM25.91 6.682c0-.02-1.388-1.422-3.085-3.118L19.741.482V6.717h3.084c1.697 0 3.085-.016 3.085-.035zm-12.181 8.407a7.434 7.434 0 01-.994-.358l-.534-.241V9.428l-.788.091c-.434.05-.996.128-1.25.171l-.46.08.093-.601c.327-2.124 2.288-4.033 4.427-4.312l.72-.094v5.245h5.245l-.094.72c-.213 1.629-1.363 3.2-2.895 3.954-.684.336-1.076.432-1.934.473-.592.028-1.283-.001-1.536-.066z"
        fill="#9a9999"
      />
      <path
        d="M6.58 26.325c-2.752-.358-5.358-.694-5.792-.748L0 25.479v-7.256c0-3.99.037-7.256.083-7.256.192 0 9.014-1.131 10.285-1.317.764-.111 1.847-.26 1.847-.26s-.014.843-.014 8.843v8.774l-.308-.016c-.17-.009-2.56-.309-5.313-.666zm-.96-6.173c0-.935-.051-.947.287-.947 1.087 0 1.906-.84 1.907-2.028 0-1.435-.465-1.823-2.187-1.823H4.524v5.758h1.097zm0-2.878v-.84l.444.042c.344.034.473.13.578.43.184.526-.224 1.105-.733 1.165-.37.043-.288.036-.288-.797z"
        fill="#ce4525"
      />
    </svg>,
  );
IconFiletypePpt.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconFiletypePpt;
